/**
 * gets querystring param from url
 * @param {String} term - param to find.
 * @param {String} url - param to find.
 */
export function getParameterByName(term, search) {
  let url = search;
  if (!url) {
    url = window.location.href.toLowerCase();
  }
  const name = term.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * checks if email is valid
 * @param {String} email - email to check.
 */
export function isEmailValid(email) {
  const emailRegex = new RegExp("(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])");
  if (email.match(emailRegex) == null) {
    return false;
  }
  return true;
}

export function isMediaOS() {
  return !!window.HRST;
}

export function isVeryLocal() {
  const url = window.location.href;
  const regex = /(?:verylocal\.com|verylocaldev\.wpengine\.com|verylocalstage\.wpengine\.com)/i;
  return regex.test(url);
}



// WEBPACK FOOTER //
// ./src/utils.js